import { defineStore } from "pinia";

export const useOnboardingStore = defineStore("onboarding", () => {
  const shown = ref({
    login: false,
    home: false,
    rank: false,
    stake: false,
    loadout: false,
  });

  const instruction = ref({
    show: false,
    text: "",
    onClose: null,
  });

  const load = () => {
    const stored = localStorage.getItem("onboarding-shown");
    if (stored) shown.value = JSON.parse(stored);
  };

  const markShown = (key) => {
    shown.value[key] = true;
    localStorage.setItem("onboarding-shown", JSON.stringify(shown.value));
  };

  const showInstruction = ({ text, onClose = null }) => {
    instruction.value = {
      show: true,
      text,
      onClose,
    };
  };

  const closeInstruction = () => {
    instruction.value.show = false;
    instruction.value.onClose();
    instruction.value.onClose = null;
  };

  return {
    shown,
    markShown,
    load,
    instruction,
    showInstruction,
    closeInstruction,
  };
});
